import { Route, Routes } from 'react-router-dom'
import { useCurrentUser } from '~/common'
import { AuthWrapped } from '~/modules/navigation/components'
import { TerminalsPage, TerminalDetailsPage, AddTerminalPage, EditTerminalPage } from '~/modules/terminals/view'
import { PATH } from '~/AppRoutes'

export const TerminalsRoutes = () => {
  const { hasRole } = useCurrentUser()
  const canAccess = hasRole('TERMINALS')
  return (
    <Routes>
      <Route index element={<TerminalsPage />} />
      <Route
        path={`${PATH.DETAILS}/:id`}
        element={<AuthWrapped component={TerminalDetailsPage} canAccess={canAccess} />}
      />
      <Route path={PATH.ADD} element={<AuthWrapped component={AddTerminalPage} canAccess={canAccess} />} />
      <Route path={`/${PATH.EDIT}/:id`} element={<AuthWrapped component={EditTerminalPage} canAccess={canAccess} />} />
    </Routes>
  )
}

export const terminalsLinks = {
  terminalsLink: () => PATH.OVERVIEW,
  terminalDetailsLink: (id: string) => `/${PATH.DETAILS}/${id}`,
  addTerminalLink: () => `/${PATH.ADD}`,
  editTerminalLink: (id: string) => `/${PATH.EDIT}/${id}`,
}
